import InvoicingPlaceholder from './InvoicingPlaceholder';

export default InvoicingPlaceholder;
